import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "stepIcon", "stepLabel", "connector", "nextBtn", "nextBtnText", "nextBtnIcon", "prevBtn", "form"]
  static values = { index: Number }

  connect() {
    if (!this.hasIndexValue) this.indexValue = 0
    this.totalValue = this.stepTargets.length
    this.render()
  }

  next(event) {
    // Find the form in the current step and submit it
    const currentStepElement = this.stepTargets[this.indexValue]
    const form = currentStepElement.querySelector('form')
    
    if (this.indexValue === 4) {
      // Last step: submit to create_from_session
      event.preventDefault()
      const publishUrl = this.nextBtnTarget.dataset.publishAction
      if (publishUrl) {
        // Create a form to submit to create_from_session
        const publishForm = document.createElement('form')
        publishForm.method = 'POST'
        publishForm.action = publishUrl
        publishForm.innerHTML = '<input type="hidden" name="authenticity_token" value="' + this.getCSRFToken() + '">'
        document.body.appendChild(publishForm)
        publishForm.submit()
      }
    } else if (form && this.indexValue < 4) {
      // For steps 0-3, submit the form which will save to session and reload
      form.requestSubmit()
    } else if (this.indexValue < this.totalValue - 1) {
      // Just move to next step
      this.indexValue++
      this.render()
    }
  }

  prev() {
    if (this.indexValue > 0) {
      this.indexValue--
      this.render()
    }
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : ''
  }

  render() {
    // Show/hide steps
    this.stepTargets.forEach((el, i) => {
      el.classList.toggle("hidden", i !== this.indexValue)
    })

    // Update step icons and labels
    this.stepIconTargets.forEach((icon, i) => {
      if (i <= this.indexValue) {
        icon.classList.remove("bg-muted", "text-muted-foreground")
        icon.classList.add("bg-primary", "text-white")
      } else {
        icon.classList.remove("bg-primary", "text-white")
        icon.classList.add("bg-muted", "text-muted-foreground")
      }
    })

    this.stepLabelTargets.forEach((label, i) => {
      if (i <= this.indexValue) {
        label.classList.remove("text-muted-foreground")
        label.classList.add("text-primary")
      } else {
        label.classList.remove("text-primary")
        label.classList.add("text-muted-foreground")
      }
    })

    // Update connectors
    this.connectorTargets.forEach((connector, i) => {
      if (i < this.indexValue) {
        connector.classList.add("bg-primary")
        connector.style.width = "100%"
      } else {
        connector.classList.remove("bg-primary")
        connector.style.width = "0%"
      }
    })

    // Update buttons
    if (this.hasNextBtnTarget) {
      const isLastStep = this.indexValue >= this.totalValue - 1
      this.nextBtnTarget.disabled = false // Never disable, but change behavior
      
      // Update button text and icon for last step
      if (this.hasNextBtnTextTarget) {
        this.nextBtnTextTarget.textContent = isLastStep ? "Publier l'annonce" : "Suivant"
      }
      
      if (this.hasNextBtnIconTarget) {
        if (isLastStep) {
          // Change icon to checkmark or publish icon
          this.nextBtnIconTarget.innerHTML = '<path d="M20 6 9 17l-5-5"/>'
        } else {
          // Restore arrow icon
          this.nextBtnIconTarget.innerHTML = '<path d="m9 18 6-6-6-6"/>'
        }
      }
    }
    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.disabled = this.indexValue <= 0
    }
  }
}


